module.exports = __webpack_public_path__ + "static/media/ws07.4ed77aba.webp";